import { pipe } from 'fp-ts/function';
import { ord, string } from 'fp-ts';
import { CardPaymentMethod, PaymentPlan, SepaPaymentMethod } from '@mews-commander/data-access';
import { PaymentCardMethod } from '@mews-commander/legacy-entities/src/ducks/paymentCards';
import { UNSPECIFIED_CREDIT_CARD_VALUE } from '@mews-commander/legacy-entities/src/ducks/payments';
import type { EmptyStateProps } from '@optimus-web/core';
import { NEW_CREDIT_CARD_VALUE } from '../../constants';

export const sortByDate = pipe(
    ord.reverse(string.Ord),
    ord.contramap((p: PaymentCardMethod | SepaPaymentMethod) => p.createdUtc)
);

export const hasPaymentMethodIdAllowedValue = (
    paymentMethodId: string,
    paymentMethods: (CardPaymentMethod | SepaPaymentMethod)[],
    allowUnspecifiedCardValue: boolean
) =>
    paymentMethodId === NEW_CREDIT_CARD_VALUE ||
    (allowUnspecifiedCardValue && paymentMethodId === UNSPECIFIED_CREDIT_CARD_VALUE) ||
    paymentMethods.some(({ id }) => id === paymentMethodId);

export const getDefaultPaymentPlanId = (
    paymentPlansForSelectedReservation: PaymentPlan[],
    defaultFormPaymentPlanId: string | null | undefined
) => {
    if (paymentPlansForSelectedReservation.some(({ id }) => id === defaultFormPaymentPlanId)) {
        return defaultFormPaymentPlanId;
    }

    if (paymentPlansForSelectedReservation.length === 1) {
        return paymentPlansForSelectedReservation[0].id;
    }

    return undefined;
};

export const getTableEmptyState = (
    primaryText: React.ReactNode,
    secondaryText?: React.ReactNode,
    action?: React.ReactNode
): EmptyStateProps => ({
    pictogram: 'folder',
    maxWidth: '500px',
    primaryText,
    secondaryText,
    action,
});
